module.exports = __webpack_public_path__ + "img/main-gallery2.bc6dafbb.jpg";